
import { Options, Vue } from 'vue-class-component'
import Employee from '@/employee/Employee'
import Farm from '@/farm/Farm'
import ValueMeter from '@/components/ui/ValueMeter.vue'
import TextButton from '@/components/ui/TextButton.vue'
import util from '@/util'

@Options({
  components: {
    ValueMeter, TextButton
  },
  props: {
    farm: Farm
  },
  methods: {
    log(msg: any) {
      console.log(msg)
    },
    util() {
      return util
    }
  }
})
export default class FarmStatusCard extends Vue {
  farm!: Farm
}
